export class AppData {
    "_patientId":'';
    "appointmentSchedule":any;
    "_teamId":any;
    "service":any;
    "notes":any;
    "acknowledgementReferral":any;
    "sentpaymentLink":any;
    "type":any;
 }